var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16634 7.49967H10.833V4.99967H13.333V3.33301H10.833V0.833008H9.16634V3.33301H6.66634V4.99967H9.16634V7.49967ZM5.83301 14.9997C4.91634 14.9997 4.17467 15.7497 4.17467 16.6663C4.17467 17.583 4.91634 18.333 5.83301 18.333C6.74967 18.333 7.49967 17.583 7.49967 16.6663C7.49967 15.7497 6.74967 14.9997 5.83301 14.9997ZM14.1663 14.9997C13.2497 14.9997 12.508 15.7497 12.508 16.6663C12.508 17.583 13.2497 18.333 14.1663 18.333C15.083 18.333 15.833 17.583 15.833 16.6663C15.833 15.7497 15.083 14.9997 14.1663 14.9997ZM6.74967 10.833H12.958C13.583 10.833 14.133 10.4913 14.4163 9.97467L17.633 4.13301L16.183 3.33301L12.958 9.16634H7.10801L3.55801 1.66634H0.833008V3.33301H2.49967L5.49967 9.65801L4.37467 11.6913C3.76634 12.808 4.56634 14.1663 5.83301 14.1663H15.833V12.4997H5.83301L6.74967 10.833Z",
    fill: "#FBFAF9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIconWhite);
export default __webpack_public_path__ + "static/media/cart_icon_white.99a9a68bb20aea516d8ffe92b8aaa793.svg";
export { ForwardRef as ReactComponent };